import React, { useEffect } from 'react'
import "./Contact.css"
import {NavLink} from "react-router-dom"

function Contact(props) {

  useEffect(()=> {
    document.title = "Lacks - About Me"
  } , [])
  return (
   <div className='body' style={props.theme}  data-aos="fade-">
    <div className="center-cont">
      <div className="flex-cont">
        <div className="img-cont">
          <img src="https://pixabay.com/get/g61d6635835d21dc18f0c6d79340b143892002dcf2e13966e507f45ca0fd43a0ee0f324114f6668a0b01cc32119ceaa89fdbd11befe32c34519882eef0b101bad_1280.jpg" alt="" className='img-fluid'  width='300'/>
        </div>
      </div>
      <div className="right-side-cont">
        <h1>About Me</h1>
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Beatae odit quae est officiis quam magni, consequuntur consequatur exercitationem a, eaque at aliquid quo numquam veniam aliquam ut fugiat expedita architecto. Molestiae debitis omnis exercitationem quis laboriosam autem sed dignissimos at quos laudantium maiores ab ut, accusantium minima harum odio adipisci?</p>
        <span>You can follow me on :</span>
        <div className="sm">
         <a href="https://www.instagram.com/yuvraj_soneja/" target='_blank'><div className="insta icn"><i class="fa-brands fa-instagram fs-2"></i></div></a> 
          <a href="https://github.com/yuvrajSoneja2004" target='_blank'><div className="github icn"><i class="fa-brands fa-github fs-2"></i></div></a>
        </div>
        <div className="center-back">
          <NavLink to='/'><button>Go Back</button></NavLink>
        </div>
      </div>
    </div>
   </div>
  )
}

export default Contact